import development from './environments/development.json';
import staging from './environments/staging.json';
import production from './environments/production.json';
const environment = process.env.NODE_ENV,
    config = {development, staging, production}[environment]; 

export default config;
